import { render, staticRenderFns } from "./ConfigTabEventTypes.vue?vue&type=template&id=627ffe2e"
import script from "./ConfigTabEventTypes.vue?vue&type=script&lang=js"
export * from "./ConfigTabEventTypes.vue?vue&type=script&lang=js"
import style0 from "./ConfigTabEventTypes.vue?vue&type=style&index=0&id=627ffe2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports